//window.usePageDots=window.PXUTheme.theme_settings.page_dots_enabled,window.imageFunctions={zoom:function(){var e=$(event.target),t=e.data("zoom-src");t&&e.wrap('<span class="zoom-container"></span>').css("display","block").parent().zoom({url:t,touch:!1,magnify:1})},linkGalleryAndCarousel:function(e,t){t.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"),t.on("click",".gallery-cell",function(){var a=$(this).index();t.find(".is-nav-selected").removeClass("is-nav-selected"),$(this).addClass("is-nav-selected"),e.flickity("select",a)}),e.on("select.flickity",function(){var e=$(this).data("flickity");e&&(t.find(".is-nav-selected").removeClass("is-nav-selected"),t.find(".gallery-cell:nth-child("+(e.selectedIndex+1)+")").addClass("is-nav-selected"))})},fullWidth:function(e,t){$(e).each(function(){var e=$(this),a=e.attr("alt"),o=e.attr("src");if(a.indexOf("[")>=0){e.remove();var s=a.match(/\[(.*?)\]/ig);a=a.replace(/\[(.*?)\]/ig,"");var r=$.map(s,function(e,t){return e=e.replace(/[\[\]']+/g,"")}),l=['<div class="position-'+(r.length?r:"center")+' caption js-caption">','<div class="caption-content caption-background-false align-'+(r.length?r:"center")+'">','<p class="headline">'+a+"</p>","</div>","</div>"].join("");e.attr({alt:a,class:"lazyload appear",src:o,dataSizes:"auto"});var n=e.prop("outerHTML");$(t).append('<div class="banner">'+n+l+"</div>")}})},showSecondaryImage:function(){window.PXUTheme.media_queries.large.matches&&($(".has-secondary-media-swap").off().on("mouseenter",function(){"select"==window.PXUTheme.theme_settings.product_form_style&&$(this).find(".product_gallery").toggleClass("secondary-media-hidden"),$(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"),$(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"),$(this).find(".external-video__container").toggleClass("secondary-media-hidden"),window.videoFeature.enableVideoOnHover($(this))}),$(".has-secondary-media-swap").on("mouseleave",function(){"select"==window.PXUTheme.theme_settings.product_form_style&&$(this).find(".product_gallery").toggleClass("secondary-media-hidden"),$(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"),$(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"),$(this).find(".external-video__container").toggleClass("secondary-media-hidden"),window.videoFeature.enableVideoOnHover($(this))}))},flickityIosFix:function(){var e,t=!1;document.body.addEventListener("touchstart",function(a){if(a.target.closest(".flickity-slider"))t=!0;else{t=!1;return}e={x:a.touches[0].pageX,y:a.touches[0].pageY}}),document.body.addEventListener("touchmove",function(a){t&&a.cancelable&&Math.abs({x:a.touches[0].pageX-e.x,y:a.touches[0].pageY-e.y}.x)>7&&a.preventDefault()},{passive:!1})}},window.recentlyViewed={init(){let e,t,a,o,s;if($(".js-product-section[data-rv-handle]").length?(e=$(".js-product-section").data("rv-handle").toString(),t=window.Cookies.get("recentlyViewed"),a=window.recentlyViewed.getCookieProducts(t,e)):$(".recently-viewed__section").length?(t=window.Cookies.get("recentlyViewed"),a=window.recentlyViewed.getCookieProducts(t,e)):$(".js-sidebar-recently-viewed").length&&(t=window.Cookies.get("recentlyViewed"),a=window.recentlyViewed.getCookieProducts(t,e)),a&&(s=unescape(a).split(",")),e?($.inArray(e,s),o=[],s.unshift(e),$.each(s,(e,t)=>{-1===$.inArray(t,o)&&o.push(t)}),window.recentlyViewed.setCookieProducts(o)):o=s,$(".recently-viewed__section").length){let r=".recently-viewed__section",l=$(r).data("recently-viewed-items-loaded");if(l)return!1;window.recentlyViewed.getProductInformation(r,o,e)}else if($(".js-recently-viewed .rv-main").length){let n=".js-recently-viewed",c=$(n).data("recently-viewed-items-loaded");if(c)return!1;window.recentlyViewed.getProductInformation(n,o,e)}if($(".sidebar .js-sidebar-recently-viewed").length){let d=".sidebar .js-sidebar-recently-viewed",u=$(d).data("recently-viewed-items-loaded");if(u)return!1;e?window.recentlyViewed.getProductInformation(d,o,e):window.recentlyViewed.getProductInformation(d,o)}},getCookieProducts:(e,t)=>(!e&&t&&window.Cookies.set("recentlyViewed",t,{expires:30,path:"/",sameSite:"None",secure:!0}),e=window.Cookies.get("recentlyViewed")),setCookieProducts(e){window.Cookies.set("recentlyViewed",escape(e.join(",")),{expires:30,path:"/",sameSite:"None",secure:!0})},getProductInformation(e,t,a){$(e).attr("data-recently-viewed-items-loaded","true"),a&&t.splice($.inArray(a,t),1);let o=$(e).data("visible-products");o&&t&&(t=t.slice(0,o)),$.each(t,(a,s)=>{s&&($(e).removeClass("hidden"),$(e).parents(".sidebar-block").show(),$.ajax({type:"GET",url:`${window.PXUTheme.routes.all_products_collection_url}/products/${s}?view=rv`,success(t){let o=$(t).find(".js-recently-viewed-product");$(e).find(`.rv-box-${a}`).append(o),$(`.rv-box-${a} [data-product-gallery]`).each((e,t)=>{let a=$(t);window.productPage.enableGallery(a)}),window.PXUTheme.currency.show_multiple_currencies&&window.currencyConverter.convertCurrencies(),window.productPage.runOptionSelector($(`.rv-box-${a}`)),Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.hideNoScript(),$(".swatch_options label").on("click",function(){window.quickShop.toggleSwatchImages($(this))}),window.PXUTheme.theme_settings.collection_secondary_image&&window.imageFunctions.showSecondaryImage();let s=o.find("[data-html5-video] video, [data-youtube-video]");s.length>0&&window.videoFeature.setupPlayerForRecentlyViewedProducts(o.find("[data-html5-video] video, [data-youtube-video]"))},error(e,t,a){console.log(e),console.log(t),console.log(a)},dataType:"html"})),$(e).find(".rv-main").hasClass("js-rv-grid")&&(t.length<=o?$(".js-rv-grid .thumbnail").eq(t.length).nextAll().addBack().remove():$(".js-rv-grid .thumbnail").eq(o).nextAll().addBack().remove())})}};var globalQuickShopProduct,enableLoadMoreProducts=function(){$("body").on("click",".js-load-more a",function(e){return enableInfiniteScroll(".product-list"),e.stopPropagation(),!1})},enableLoadMoreButton=function(e){var t=e+"[data-load-more--grid]",a=e+" [data-load-more--grid-item]";$("body").on("click","[data-load-more]",function(e){e.preventDefault();var o,s,r=$(this);o=r.attr("href"),s=r,$.ajax({type:"GET",dataType:"html",url:o,beforeSend:function(){s.addClass("is-loading"),$(".load-more__icon").addClass("loading-in-progress").css({height:"40px",width:"40px",opacity:"1"})},success:function e(o){s.removeClass("is-loading"),$(".load-more__icon").removeClass("loading-in-progress").css({height:"0",width:"0",opacity:"0"});let r=$(o).find(a);var l=$(o).find("[data-load-more]").attr("href");$("[data-load-more]").attr("href",l),$(t).first().append(r).append($(".js-load-more")),window.PXUTheme.currency.show_multiple_currencies&&window.currencyConverter.convertCurrencies(),window.productPage.init(),window.productPage.runOptionSelector(r),Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.PXUTheme.theme_settings.quick_shop_enabled&&window.quickShop.init(),window.hideNoScript(),window.videoFeature.init(),window.PXUTheme.theme_settings.collection_secondary_image&&window.imageFunctions.showSecondaryImage(),void 0===l&&$("[data-load-more]").addClass("is-hidden")},error:function(e,t,a){console.log(e),console.log(t),console.log(a),location.replace(location.protocol+"//"+location.host+filterURL)}})})},enableInfiniteScroll=function(e){$(e).length&&new Waypoint.Infinite({element:$(e)[0],items:e,more:"[data-load-more]",loadingClass:"loading-in-progress",onBeforePageLoad:function(){$(".js-load-more").hide()},onAfterPageLoad:function(t){let a=$(`${e} [data-load-more--grid-item]`),o=$(t).find(a);$(`${e} > ${e} .thumbnail`).unwrap(e),window.PXUTheme.currency.show_multiple_currencies&&window.currencyConverter.convertCurrencies(),window.productPage.init(),window.productPage.runOptionSelector(o),Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.PXUTheme.theme_settings.quick_shop_enabled&&window.quickShop.init(),window.hideNoScript(),window.videoFeature.init(),window.PXUTheme.theme_settings.collection_secondary_image&&window.imageFunctions.showSecondaryImage(),Waypoint.refreshAll()}})};if(window.hideNoScript=function(){$(".image__container .noscript").addClass("hidden")},Shopify.queryParams={},location.search.length)for(var aKeyValue,i=0,aCouples=location.search.substr(1).split("&");i<aCouples.length;i++)(aKeyValue=aCouples[i].split("=")).length>1&&(Shopify.queryParams[decodeURIComponent(aKeyValue[0])]=decodeURIComponent(aKeyValue[1]));var quickFilter={init:function(){var e=[],t="",a="";if(t=$("#sort-by").length?$("#sort-by").val():url("?sort_by"),$("#tag_filter").length){var o=$("#tag_filter").val();if($("#tag_filter").data("default-collection")!=o){urlTag=o.substr(o.lastIndexOf("/")+1);var s=o.substr(o);$("#tag_filter option").removeAttr("selected"),$('#tag_filter option[value="'+s+'"]').attr("selected","selected"),"all"!=urlTag&&($.inArray(urlTag,e)>-1||e.unshift(urlTag))}}$("[data-option-filter] input:checked").each(function(){e.push($(this).val())}),e=$.makeArray(e),$.each(e,function(t,o){t!=e.length-1?a+=e[t]+"+":a+=e[t]}),Shopify.queryParams.sort_by=t,t="?"+$.param(Shopify.queryParams).replaceAll("%2B","+"),quickFilter.processUrl(a,t)},updateView:function(e){$.ajax({type:"GET",url:e,beforeSend:function(){$(".product-list--collection").addClass("fadeOut animated loading-in-progress filter-loading"),Waypoint.destroyAll()},success:function(t){let a=$(".product-list--collection [data-load-more--grid-item"),o=$(t).find(a);$(".product-list--collection").removeClass("loading-in-progress"),$(".product-list--collection").removeClass("filter-loading");var s=$(t).find(".breadcrumb_text").html();$(".breadcrumb_text").html(s);var r=$(t).find(".paginate").html();$(".paginate").html(r);var l=$(t).find(".sidebar").html();$(".sidebar").html(l);var n=$(t).find(".paginate").html();$(".paginate").empty(),$(".paginate").html(n);var c=$(t).find(".product-list--collection");$(".product-list--collection").remove(),c.insertBefore($(".load-more__icon")),window.history&&window.history.pushState&&window.history.pushState("","",e),$(".sidebar__collection-filter").length&&window.collectionSidebarFilter.init(),window.recentlyViewed.init(),window.PXUTheme.currency.show_multiple_currencies&&window.currencyConverter.convertCurrencies(),window.productPage.init(),window.productPage.runOptionSelector(o),Shopify.PaymentButton&&Shopify.PaymentButton.init(),$("body").off("click",".swatch-element"),window.productPage.productSwatches(),$(".swatch_options label").on("click",function(){window.quickShop.toggleSwatchImages($(this))}),"load_more"===window.PXUTheme.theme_settings.pagination_type&&window.enableLoadMoreProducts(),"load_more_button"===window.PXUTheme.theme_settings.pagination_type&&window.enableLoadMoreButton(".product-list"),"infinite_scroll"===window.PXUTheme.theme_settings.pagination_type&&window.enableInfiniteScroll(".product-list")},error:function(t,a,o){console.log(t),console.log(a),console.log(o),location.replace(location.protocol+"//"+location.host+e)},dataType:"html"})},processUrl:function(e,t){let{pathname:a}=window.location,o=t.replace(/\page=(\w+)&/,""),s="/"===a.slice(-1)?a:`${a}/`;quickFilter.updateView(s+e+o)}};window.searchAutocomplete={vars:{term:"",searchPath:window.PXUTheme.routes.search_url,displayTimer:""},init:function(){this.unload(),$("[data-autocomplete-true]").on("focus",function(){$(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()}),$(document).on("click focusout",function(e){window.PXUTheme.media_queries.large.matches&&0===$(e.target).parents(".search__form").length&&$("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")}),$('[data-dropdown-rel="search"]').on("click",function(e){if(window.PXUTheme.theme_settings.enable_autocomplete&&window.PXUTheme.media_queries.medium.matches){e.preventDefault();var t=$(this).closest("form").find('[name="type"]').val(),a=$(document).scrollTop();window.searchAutocomplete.showMobileSearch(t,a)}}),$(".search-close").on("click touchstart",function(){$("body").removeClass("is-active"),$(".dropdown_link").removeClass("active_link"),$(".dropdown_container").hide(),$(".mobile_nav").find("div").removeClass("open"),$("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")}),$("[data-autocomplete-true] form").on("submit",function(e){e.preventDefault();var t=$(this).find('input[name="q"]').val(),a=encodeURI(t);if($(this).find('[name="type"]').length>0)var o=$(this).find('[name="type"]').val();else var o=window.PXUTheme.theme_settings.search_option;null==a?window.location.href=window.PXUTheme.routes.search_url+"?type="+o:window.location.href=window.searchAutocomplete.vars.searchPath+"?type="+o+"&q="+a+"*"}),$("[data-autocomplete-true] form").each(function(){var e=$(this),t=e.find('input[name="q"]');$('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo(e),t.attr("autocomplete","off").on("input",function(){clearTimeout(window.searchAutocomplete.vars.displayTimer),$(this).val().length>3?(window.searchAutocomplete.vars.term=$(this).val(),window.searchAutocomplete.getResults(window.searchAutocomplete.vars.term,e)):$("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")})})},getResults:function(e,t){if(t.find('[name="type"]').length>0)var a=t.find('[name="type"]').val();else var a=window.PXUTheme.theme_settings.search_option;jQuery.getJSON("/search/suggest.json",{q:e,resources:{type:a,limit:window.PXUTheme.theme_settings.search_items_to_display,options:{unavailable_products:"last",fields:"title,body,variants.title,vendor,product_type,tag"}}}).done(function(e){var a=[e.resources.results.products,e.resources.results.pages,e.resources.results.articles],o=[];$.each(a,function(e,t){void 0!==t&&t.length>0&&o.push(t)}),window.searchAutocomplete.vars.displayTimer=setTimeout(function(){window.searchAutocomplete.displayResults(o[0],t)},500)})},displayResults:function(e,t){var a=t.find(".search__results-wrapper"),o=t.find(".search__results");if(a.show(),o.empty(),t.find('[name="type"]').length>0)var s=t.find('[name="type"]').val();else var s=window.PXUTheme.theme_settings.search_option;if(e&&e.length>0)$.each(e,function(e,t){var a=$('<a tabindex="0"></a>').attr("href",t.url);if("/"!==window.PXUTheme.routes.root_url&&(a=$('<a tabindex="0"></a>').attr("href",window.PXUTheme.routes.root_url+t.url)),t.price){function s(e){return"money_with_currency_format"===window.PXUTheme.currency.display_format?`<span class="money">${window.PXUTheme.currency.symbol}${e} ${window.PXUTheme.currency.iso_code}</span>`:`<span class="money">${window.PXUTheme.currency.symbol}${e}</span>`}if(!0===t.available){let r=parseFloat(t.compare_at_price_max),l=parseFloat(t.compare_at_price_min),n=parseFloat(t.price_min),c=parseFloat(t.price_max),d=parseFloat(t.price);if(r>c||l>n)var u=s(t.price)+' <span class="was_price">'+s(t.compare_at_price_min)+"</span>";else if(d>0){if(n!=c)var u=window.PXUTheme.translation.from_text+" "+s(t.price);else var u=s(t.price)}else var u=window.PXUTheme.theme_settings.free_text}else var u=window.PXUTheme.translation.sold_out_text;t.image&&a.append('<div class="thumbnail"><img class="lazyload transition--'+window.PXUTheme.theme_settings.image_loading_style+'" src="'+window.utils.addImageDimension(t.image,"_300x")+'" /></div>'),a.append('<div class="search-title">'+t.title+'<br><span class="item-pricing price">'+u+"</span></div>")}else t.summary_html?("NULL"!=t.image&&a.append('<div class="thumbnail"><img class="lazyload transition--'+window.PXUTheme.theme_settings.image_loading_style+'" src="'+window.utils.addImageDimension(t.image,"_300x")+'" /></div>'),a.append('<div class="search-title">'+t.title+'<br><span class="item-description">'+t.summary_html.replace(/(<([^>]+)>)/ig,"").slice(0,25)+" </span></div>")):t.published_at&&a.append('<div class="search-title">'+t.title+'<br><span class="item-description">'+t.body.replace(/(<([^>]+)>)/ig,"").slice(0,25)+" </span></div>");a.wrap('<li class="item-result"></li>'),o.append(a.parent())}),o.append('<li class="all-results"><span class="search-title see-all"><a href="'+this.vars.searchPath+"?type="+s+"&q="+this.vars.term+'*"><span>'+window.PXUTheme.translation.all_results+'</span><span class="icon-right-arrow"></span></a></span></li>'),(window.PXUTheme.currency.show_multiple_currencies||window.PXUTheme.currency.native_multi_currency)&&window.currencyConverter.init(),o.parents(".search__results-wrapper").addClass("results-found");else{var r='<li class="item-result"><span class="no-results search-title">'+window.PXUTheme.translation.no_results+"</span></li>";o.append(r),o.parents(".search__results-wrapper").removeClass("results-found")}o.show()},showMobileSearch:function(e,t){$("body").css("max-height",window.innerHeight),$(".mobile-search").fadeIn(200),/iPad|iPhone|iPod/.test(navigator.platform)||"MacIntel"===navigator.platform&&navigator.maxTouchPoints>1?$(".mobile-search input#q").focus():setTimeout(function(){$(".mobile-search input#q").focus()},205),document.body.style.position="fixed",document.body.style.top="-"+t+"px",$(".mobile-search").css("top",t);var a=window.innerHeight-60;$(".mobile-search .search__results-wrapper").css("max-height",a),e?$('.mobile-search [name="type"]').val(e):$('.mobile-search [name="type"]').val(window.PXUTheme.theme_settings.search_option),$(".search-form .close-search").on("click touchstart",function(e){e.preventDefault(),e.stopPropagation(),window.searchAutocomplete.hideMobileSearch(t),$("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")}),$(".search-form .submit-search").on("click touchstart",function(e){$(this).parents("form").submit()})},hideMobileSearch:function(e){$("body").css("max-height","none"),document.body.style.position="",document.body.style.top="",window.scrollTo(0,e),$(".mobile-search").fadeOut(200),$('.mobile-search [name="q"]').val(""),$("body").off("focus",".search-form .close-search"),$("body").off("focus",".search-form .submit-search")},unload:function(){$("body").off("focus","[data-autocomplete-true] input"),$('input[name="q"]').off(),$('[data-dropdown-rel="search"], [data-autocomplete-true] input').off(),$(".search__results-wrapper").remove()}},window.collectionSidebarFilter={init:function(){$(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(),(()=>{let e=document.querySelector("[data-sidebar]");if(!e)return;let t=e.querySelectorAll("[data-sidebar-block]");window.PXUTheme.media_queries.medium.matches||t.forEach(e=>{e.querySelector("[data-active-legacy-filter]")&&(e.open=!0)})})(),("types"===$.url(2)||"vendors"===$.url(2))&&$(".sidebar__collection-filter").remove(),$(".sidebar-block:empty").prev().css("border-bottom","none"),window.recentlyViewed.init()},clearAllFilters:function(){$("[data-option-filter] input").prop("checked",!1),$("[data-option-filter] input").trigger("change"),window.recentlyViewed.init()},clearSelectedFilter:function(e){$("#tag_filter").length&&e.find("[data-option-filter] input").val()===$("#tag_filter option:selected ").val().substr($("#tag_filter option:selected ").val().lastIndexOf("/")+1)&&$("#tag_filter").val($("#tag_filter option:first").val()),e.find("[data-option-filter] input").prop("checked",!1),e.find("[data-option-filter] input").trigger("change"),window.recentlyViewed.init()}},window.sidebarAccordions={init:function(){let e=document.querySelector("[data-sidebar]");if(!e)return;let t=e.querySelectorAll("[data-sidebar-block]"),a=e.querySelector("[data-faceted-filter-form]"),o="true"===e.dataset.sidebarAllowToggle,s=()=>t.forEach(e=>{e.open=!1}),r=()=>t.forEach(e=>{e.open=!0}),l=!1,n=()=>{window.PXUTheme.media_queries.medium.matches?(l||s(),l=!0):(o||r(),l=!1)};if(n(),window.addEventListener("resize",n),a){a.addEventListener("keypress",e=>{e.target.classList.contains("faceted-filter-group-display__list-item-input")&&13==event.keyCode&&(e.target.checked?e.target.checked=!1:e.target.checked=!0)});let c=document.querySelector("[data-sort-by]");a.addEventListener("change",e=>{if("number"!=e.target.type){if(c){let t=c.value,o=new FormData(a),s=new URLSearchParams(o);s.set("sort_by",t),window.location.search=s}else a.submit()}})}t.forEach(e=>{let t=e.querySelector("summary");if(!t)return;let a=window.animations.transition({el:e,state:e.open?"open":"closed",stateAttribute:"data-sidebar-block-state",stateChangeAttribute:"data-sidebar-block-animation"});t.addEventListener("click",s=>{if(s.preventDefault(),!window.PXUTheme.media_queries.medium.matches&&!o)return;let{height:r}=t.getBoundingClientRect();e.style.setProperty("--closed-height",`${r}px`),e.open?(e.style.setProperty("--open-height",`${e.scrollHeight}px`),a.animateTo("closed").then(()=>{e.open=!1})):(e.open=!0,a.animateTo("open",{onStart(){e.style.setProperty("--open-height",`${e.scrollHeight}px`)}}))})})}},"bold"==window.PXUTheme.theme_settings.slideshow_arrow_size?(window.arrowSize={x0:10,x1:40,y1:50,x2:80,y2:50,x3:50},window.svgArrowSizeLeft='<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>',window.svgArrowSizeRight='<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'):"light"==window.PXUTheme.theme_settings.slideshow_arrow_size?(window.arrowSize={x0:10,x1:60,y1:50,x2:62,y2:40,x3:22},window.svgArrowSizeLeft='<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',window.svgArrowSizeRight='<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'):"regular"==window.PXUTheme.theme_settings.slideshow_arrow_size&&(window.arrowSize={x0:10,x1:60,y1:50,x2:70,y2:40,x3:30},window.svgArrowSizeLeft='<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',window.svgArrowSizeRight='<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'),window.isScreenSizeLarge=function e(){if(window.matchMedia("(min-width: 1024px)").matches)return!0},window.utils={createAccordion:function(e,t,a){var o=$(e),s=$(e).find(t),r=$(e).find(a),l=e+" "+t;if(e.indexOf(".accordion-tabs")>=0){var n=$.map(s,function(e,t){return[e,r[t]]});o.empty(),$.each(n,function(e,t){o.append(this)}),r.removeClass("active"),o.find(".active").next().slideToggle(),t=e+"> a"}$(e).children("a").each(function(e,t){var t=$(this),a=t.attr("href");t.attr("data-tab-value",a),t.removeAttr("href")}),$(e).find(t+".active").next().slideToggle(),$("body").on("click",l,function(e){e.preventDefault(),$(this).toggleClass("active"),$(this).next().slideToggle()})},mobileAccordion:function(e,t,a){$container=$(e),$tab=$(e).find(t),$content=$(e).find(a),$(t+".active").next().slideToggle(),$("body").on("click",t,function(e){e.preventDefault(),$(this).toggleClass("active"),$(this).next().slideToggle()})},mobileParentActiveAccordion:function(e,t,a){$container=$(e),$tab=$(e).find(t),$content=$(e).find(a),$(t+".active").parent().next().slideToggle(),$("body").on("click",t,function(e){e.preventDefault(),$(this).toggleClass("active"),$(this).parent().next().slideToggle()})},initializeTabs:function(){$("ul.tabs > li > a").attr("data-no-instant",!0),$("body").on("click","ul.tabs > li > a",function(e){e.preventDefault();var t=$(this).attr("href");"#"==t.charAt(0)&&($("ul.tabs > li > a.active").removeClass("active"),$(this).addClass("active"),$(this).parents("ul.tabs").next().find(t).show().css({display:"block"}).addClass("active").siblings().hide().removeClass("active"))})},scrollToTop:function(e,t){void 0!=t?$("html, body").animate({scrollTop:$(e).offset().top-t},1e3):$("html, body").animate({scrollTop:$(e).offset().top},1e3)},initializeSectionWrapper:function(){let e=document.querySelector(".section-wrapper .shopify-section");e&&(window.navigationDesktopManager.initAll(),e.classList.contains("under-menu")&&e.querySelector(".full-width--true")?($(".header").hasClass("header-background--solid")||($(".header").parent().addClass("feature_image"),$(".header").addClass("is-absolute")),$(".feature_image").hasClass("secondary_logo--true")&&($(".secondary_logo--true").find(".secondary_logo").show(),$(".secondary_logo--true").find(".primary_logo").hide()),window.headerFader.updateShouldFade(!0)):($(".feature_image").removeClass("feature_image"),$(".header.is-absolute").removeClass("is-absolute"),$("header.feature_image").hasClass("secondary_logo--true")||($(".secondary_logo--true").find(".secondary_logo").hide(),$(".secondary_logo--true").find(".primary_logo").show()),window.headerFader.updateShouldFade(!1)))},enableDisclosure:function(){var e=$("[data-disclosure]"),t=$("[data-disclosure-toggle]"),a=$(".disclosure__list-wrap");function o(e){e.siblings(".disclosure__list-wrap").is(":off-right")&&e.siblings(".disclosure__list-wrap").addClass("disclosure--left")}function s(e,o){!0===e?(t.not(o).removeClass("is-clicked"),t.not(o).attr("aria-expanded","false")):(t.removeClass("is-clicked"),t.attr("aria-expanded","false")),a.removeClass("disclosure--left")}$("body").on("keyup",function(e){"27"==e.which&&s()}),e.on("mouseleave",function(e){s()}),t.on("mouseenter focus",function(e){s(!0,this);var t=$(e.currentTarget);t.attr("aria-expanded","true").addClass("is-clicked"),o(t)}),$(".disclosure__button").on("focusout",function(e){(!$(e.relatedTarget).hasClass("disclosure__button")||$(e.relatedTarget).hasClass("disclosure__toggle"))&&s()}),t.on("touchstart",function(e){if(window.PXUTheme.media_queries.medium.matches||!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){var t=$(e.currentTarget);s(!0,this),t.hasClass("is-clicked")?(t.attr("aria-expanded","false").removeClass("is-clicked"),a.removeClass("disclosure--left")):(t.attr("aria-expanded","true").addClass("is-clicked"),o(t))}})},addImageDimension:function(e,t){var a=e.lastIndexOf(".");return e.substring(0,a)+t+e.substring(a)},unload:function(e){$("[data-disclosure]").off(),$("[data-disclosure-toggle]").off()}},window.sliderBlock={select:function(e,t){var a=t.find(".gallery-cell").map(function(){return String($(this).data("block-id"))}),o=t.find("[data-slider-id]");o.data("slideshow-text-animation");var s=o.data("flickity");o.flickity("pausePlayer");for(var r=0;r<a.length;r++)if(a[r]===e){var l=r;l!==s.selectedIndex&&o.flickity("select",parseInt(l),!1,!0)}},deselect:function(e){var t=e.find(".flexslider").data("flexslider");t&&t.flickity("unpausePlayer")}},window.quickShop={init:function(){$("body").on("click",".js-quick-shop-link",e=>{e.preventDefault();let t=$(e.currentTarget);window.productPage.loadQuickshop(t.data("url")).then(e=>{if(!e)return;let a=e.html;$(".js-quick-shop").html(a.content),$(".fancybox-active").length||$.fancybox.open($(".js-quick-shop"),{baseClass:`quick-shop__lightbox product-${t.data("id")}`,hash:!1,infobar:!1,toolbar:!1,loop:!1,smallBtn:!0,video:{autoStart:!1},touch:!1,mobile:{preventCaptionOverlap:!1,toolbar:!0,buttons:["close"]},beforeLoad(){window.productPage.init(),window.productPage.runOptionSelector($(".js-quick-shop")),window.accordion.init(),videoFeature.setupVideoPlayer(),productMedia.setupMedia(),utils.initializeTabs(),productPage.productSwatches(),Shopify.PaymentButton&&Shopify.PaymentButton.init()},afterShow(e,t){let{src:a}=t,o=$(a).find(".quick-shop");o.addClass("quick-shop--loaded"),o.addClass("content-loaded")},beforeClose(e,t){let{src:a}=t,o=$(a).find(".quick-shop");o.removeClass("quick-shop--loaded"),o.removeClass("content-loaded")}})}).catch(e=>console.error(e))}),$(".swatch_options label").on("click",function(){window.quickShop.toggleSwatchImages($(this))})},toggleSwatchImages:function(e){var t=$(e).data("image"),a=$(e).parents(".thumbnail").find(".image__container img");a.attr("src",t),a.attr("srcset",t)}},window.newsletter_popup={init:function(){var e=window.Cookies.get("popup"),t=parseInt(window.PXUTheme.theme_settings.newsletter_popup_days),a=0!=t;if(a&&"open"==e)return!1;window.newsletter_popup.open(),a&&window.Cookies.set("popup","open",{expires:t,path:"",domain:"",sameSite:"None",secure:!0})},open:function(){var e=parseInt(window.PXUTheme.theme_settings.newsletter_popup_seconds);(window.PXUTheme.theme_settings.newsletter_popup_mobile||window.PXUTheme.media_queries.large.matches)&&setTimeout(function(){$.fancybox.open($(".js-newsletter-popup"),{baseClass:"newsletter__lightbox",hash:!1,infobar:!1,toolbar:!1,loop:!0,smallBtn:!0,mobile:{preventCaptionOverlap:!1,toolbar:!0,buttons:["close"]}})},1e3*e)}},window.productMedia={models:[],setupMedia:function(){var e={controls:["zoom-in","zoom-out","fullscreen"],focusOnPlay:!1};$($("model-viewer",$(".js-product-gallery, .js-gallery-modal"))).each(function(t,a){a=new Shopify.ModelViewerUI(a,e),window.productMedia.models.push(a)}),$(".product-gallery__model model-viewer").on("mousedown",function(){window.productMedia.hideModelIcon(this)})},showModelIcon:function(e){$(e).find(".button--poster, .model-icon-button-control").show()},hideModelIcon:function(e){$(e).find(".button--poster, .model-icon-button-control").hide()}},window.videoEl={playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',playButton:'<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',muteButton:'<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',progressInput:'<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',volume:'<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',fullscreen:'<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'},window.videoControls=window.videoEl.playButtonIcon+'<div class="plyr__controls">'+window.videoEl.playButton+window.videoEl.progressInput+window.videoEl.muteButton+videoEl.volume+window.videoEl.fullscreen+"</div>",window.globalVideoPlayers=[],window.videoPlayers=[],window.videosInRecommendedProductsPlayer,window.videoFeature={init:function(){this.setupVideoPlayer(),this.setupRecommendedVideoPlayer()},setupVideoPlayer:function(){var e=document.querySelectorAll("[data-html5-video] video, [data-youtube-video]"),t=Plyr.setup(e,{controls:window.videoControls,ratio:this.aspect_ratio,fullscreen:{enabled:!0,fallback:!0,iosNative:!0},storage:{enabled:!1}});window.globalVideoPlayers&&$.each(t,function(e,t){window.globalVideoPlayers.push(t)});var a=$("[data-video-loop]").data("video-loop")||!1;$.each(t,function(e,t){t.loop=a,window.videoPlayers.push(t)}),this.setupListeners()},setupPlayerForRecentlyViewedProducts:function(e){if(e){var t=new Plyr(e,{controls:window.videoControls,ratio:this.aspect_ratio,fullscreen:{enabled:!0,fallback:!0,iosNative:!0},storage:{enabled:!1}});null!==window.videoPlayers&&(window.videoPlayers.push(t),this.setupListeners())}},setupRecommendedVideoPlayer:function(){var e=document.querySelectorAll(".product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]");if(e.length>0){if(window.videosInRecommendedProductsPlayer=Plyr.setup(e,{controls:window.videoControls,fullscreen:{enabled:!0,fallback:!0,iosNative:!0},storage:{enabled:!1}}),null!==window.videoPlayers){var t=window.videoPlayers.concat(window.videosInRecommendedProductsPlayer);window.videoPlayers=t}else window.videoPlayers=videosInRecommendedProductsPlayer}this.setupListeners()},setupListeners:function(){$.each(window.videoPlayers,function(e,t){var a,o=t.id||t.media.dataset.plyrVideoId;t.isHTML5&&(a=$(t.elements.wrapper).find("video")).attr("data-plyr-video-id",o)}),$.each(window.globalVideoPlayers,function(e,t){t.on("play",function(e){var t=e.detail.plyr;$.each(window.globalVideoPlayers,function(e,a){t.id!=a.id&&a.pause()})})})},enableVideoOnHover:function(e){var t,a=e.find("[data-html5-video]"),o=e.find("[data-youtube-video]");a.length>0?t=a.find("[data-plyr-video-id]").data("plyr-video-id"):o.length>0&&(t=o.find("iframe").attr("id")),t&&$.each(window.videoPlayers,function(e,a){(a.id==t||a.media.id==t)&&(a.toggleControls(!1),a.muted=!0,a.play())})},disableVideoOnHover:function(e){var t,a=e.find("[data-html5-video]"),o=e.find("[data-youtube-video]");a.length>0?t=a.find("[data-plyr-video-id]").data("plyr-video-id"):o.length>0&&(t=o.find("iframe").attr("id")),t&&$.each(window.videoPlayers,function(e,a){(a.id==t||a.media.id==t)&&a.playing&&a.pause()})}};

/** Shopify CDN: Minification failed

Line 16:2814 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:2817 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:3484 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:3677 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:3867 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:4251 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:4382 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:4474 Transforming let to the configured target environment ("es5") is not supported yet
Line 16:4727 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:4731 Transforming let to the configured target environment ("es5") is not supported yet
... and 30 more hidden warnings

**/
window.usePageDots = window.PXUTheme.theme_settings.page_dots_enabled,
window.imageFunctions = {
    zoom: function() {
        var e = $(event.target)
          , t = e.data("zoom-src");
        t && e.wrap('<span class="zoom-container"></span>').css("display", "block").parent().zoom({
            url: t,
            touch: !1,
            magnify: 1
        })
    },
    linkGalleryAndCarousel: function(e, t) {
        t.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"),
        t.on("click", ".gallery-cell", function() {
            var a = $(this).index();
            t.find(".is-nav-selected").removeClass("is-nav-selected"),
            $(this).addClass("is-nav-selected"),
            e.flickity("select", a)
        }),
        e.on("select.flickity", function() {
            var e = $(this).data("flickity");
            e && (t.find(".is-nav-selected").removeClass("is-nav-selected"),
            t.find(".gallery-cell:nth-child(" + (e.selectedIndex + 1) + ")").addClass("is-nav-selected"))
        })
    },
    fullWidth: function(e, t) {
        $(e).each(function() {
            var e = $(this)
              , a = e.attr("alt")
              , o = e.attr("src");
            if (a.indexOf("[") >= 0) {
                e.remove();
                var s = a.match(/\[(.*?)\]/ig);
                a = a.replace(/\[(.*?)\]/ig, "");
                var r = $.map(s, function(e, t) {
                    return e = e.replace(/[\[\]']+/g, "")
                })
                  , l = ['<div class="position-' + (r.length ? r : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (r.length ? r : "center") + '">', '<p class="headline">' + a + "</p>", "</div>", "</div>"].join("");
                e.attr({
                    alt: a,
                    class: "lazyload appear",
                    src: o,
                    dataSizes: "auto"
                });
                var n = e.prop("outerHTML");
                $(t).append('<div class="banner">' + n + l + "</div>")
            }
        })
    },
    showSecondaryImage: function() {
        window.PXUTheme.media_queries.large.matches && ($(".has-secondary-media-swap").off().on("mouseenter", function() {
            "select" == window.PXUTheme.theme_settings.product_form_style && $(this).find(".product_gallery").toggleClass("secondary-media-hidden"),
            $(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"),
            $(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"),
            $(this).find(".external-video__container").toggleClass("secondary-media-hidden"),
            window.videoFeature.enableVideoOnHover($(this))
        }),
        $(".has-secondary-media-swap").on("mouseleave", function() {
            "select" == window.PXUTheme.theme_settings.product_form_style && $(this).find(".product_gallery").toggleClass("secondary-media-hidden"),
            $(this).find(".image-element__wrap img").toggleClass("secondary-media-hidden"),
            $(this).find("[data-html5-video]").toggleClass("secondary-media-hidden"),
            $(this).find(".external-video__container").toggleClass("secondary-media-hidden"),
            window.videoFeature.enableVideoOnHover($(this))
        }))
    },
    flickityIosFix: function() {
        var e, t = !1;
        document.body.addEventListener("touchstart", function(a) {
            if (a.target.closest(".flickity-slider"))
                t = !0;
            else {
                t = !1;
                return
            }
            e = {
                x: a.touches[0].pageX,
                y: a.touches[0].pageY
            }
        }),
        document.body.addEventListener("touchmove", function(a) {
            t && a.cancelable && Math.abs({
                x: a.touches[0].pageX - e.x,
                y: a.touches[0].pageY - e.y
            }.x) > 7 && a.preventDefault()
        }, {
            passive: !1
        })
    }
},
window.recentlyViewed = {
    init() {
        let e, t, a, o, s;
        if ($(".js-product-section[data-rv-handle]").length ? (e = $(".js-product-section").data("rv-handle").toString(),
        t = window.Cookies.get("recentlyViewed"),
        a = window.recentlyViewed.getCookieProducts(t, e)) : $(".recently-viewed__section").length ? (t = window.Cookies.get("recentlyViewed"),
        a = window.recentlyViewed.getCookieProducts(t, e)) : $(".js-sidebar-recently-viewed").length && (t = window.Cookies.get("recentlyViewed"),
        a = window.recentlyViewed.getCookieProducts(t, e)),
        a && (s = unescape(a).split(",")),
        e ? ($.inArray(e, s),
        o = [],
        s.unshift(e),
        $.each(s, (e,t)=>{
            -1 === $.inArray(t, o) && o.push(t)
        }
        ),
        window.recentlyViewed.setCookieProducts(o)) : o = s,
        $(".recently-viewed__section").length) {
            let r = ".recently-viewed__section"
              , l = $(r).data("recently-viewed-items-loaded");
            if (l)
                return !1;
            window.recentlyViewed.getProductInformation(r, o, e)
        } else if ($(".js-recently-viewed .rv-main").length) {
            let n = ".js-recently-viewed"
              , c = $(n).data("recently-viewed-items-loaded");
            if (c)
                return !1;
            window.recentlyViewed.getProductInformation(n, o, e)
        }
        if ($(".sidebar .js-sidebar-recently-viewed").length) {
            let d = ".sidebar .js-sidebar-recently-viewed"
              , u = $(d).data("recently-viewed-items-loaded");
            if (u)
                return !1;
            e ? window.recentlyViewed.getProductInformation(d, o, e) : window.recentlyViewed.getProductInformation(d, o)
        }
    },
    getCookieProducts: (e,t)=>(!e && t && window.Cookies.set("recentlyViewed", t, {
        expires: 30,
        path: "/",
        sameSite: "None",
        secure: !0
    }),
    e = window.Cookies.get("recentlyViewed")),
    setCookieProducts(e) {
        window.Cookies.set("recentlyViewed", escape(e.join(",")), {
            expires: 30,
            path: "/",
            sameSite: "None",
            secure: !0
        })
    },
    getProductInformation(e, t, a) {
        $(e).attr("data-recently-viewed-items-loaded", "true"),
        a && t.splice($.inArray(a, t), 1);
        let o = $(e).data("visible-products");
        o && t && (t = t.slice(0, o)),
        $.each(t, (a,s)=>{
            s && ($(e).removeClass("hidden"),
            $(e).parents(".sidebar-block").show(),
            $.ajax({
                type: "GET",
                url: `${window.PXUTheme.routes.all_products_collection_url}/products/${s}?view=rv`,
                success(t) {
                    let o = $(t).find(".js-recently-viewed-product");
                    $(e).find(`.rv-box-${a}`).append(o),
                    $(`.rv-box-${a} [data-product-gallery]`).each((e,t)=>{
                        let a = $(t);
                        window.productPage.enableGallery(a)
                    }
                    ),
                    window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies(),
                    window.productPage.runOptionSelector($(`.rv-box-${a}`)),
                    Shopify.PaymentButton && Shopify.PaymentButton.init(),
                    window.hideNoScript(),
                    $(".swatch_options label").on("click", function() {
                        window.quickShop.toggleSwatchImages($(this))
                    }),
                    window.PXUTheme.theme_settings.collection_secondary_image && window.imageFunctions.showSecondaryImage();
                    let s = o.find("[data-html5-video] video, [data-youtube-video]");
                    s.length > 0 && window.videoFeature.setupPlayerForRecentlyViewedProducts(o.find("[data-html5-video] video, [data-youtube-video]"))
                },
                error(e, t, a) {
                    console.log(e),
                    console.log(t),
                    console.log(a)
                },
                dataType: "html"
            })),
            $(e).find(".rv-main").hasClass("js-rv-grid") && (t.length <= o ? $(".js-rv-grid .thumbnail").eq(t.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(o).nextAll().addBack().remove())
        }
        )
    }
};
var globalQuickShopProduct, enableLoadMoreProducts = function() {
    $("body").on("click", ".js-load-more a", function(e) {
        return enableInfiniteScroll(".product-list"),
        e.stopPropagation(),
        !1
    })
}, enableLoadMoreButton = function(e) {
    var t = e + "[data-load-more--grid]"
      , a = e + " [data-load-more--grid-item]";
    $("body").on("click", "[data-load-more]", function(e) {
        e.preventDefault();
        var o, s, r = $(this);
        o = r.attr("href"),
        s = r,
        $.ajax({
            type: "GET",
            dataType: "html",
            url: o,
            beforeSend: function() {
                s.addClass("is-loading"),
                $(".load-more__icon").addClass("loading-in-progress").css({
                    height: "40px",
                    width: "40px",
                    opacity: "1"
                })
            },
            success: function e(o) {
                s.removeClass("is-loading"),
                $(".load-more__icon").removeClass("loading-in-progress").css({
                    height: "0",
                    width: "0",
                    opacity: "0"
                });
                let r = $(o).find(a);
                var l = $(o).find("[data-load-more]").attr("href");
                $("[data-load-more]").attr("href", l),
                $(t).first().append(r).append($(".js-load-more")),
                window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies(),
                window.productPage.init(),
                window.productPage.runOptionSelector(r),
                Shopify.PaymentButton && Shopify.PaymentButton.init(),
                window.PXUTheme.theme_settings.quick_shop_enabled && window.quickShop.init(),
                window.hideNoScript(),
                window.videoFeature.init(),
                window.PXUTheme.theme_settings.collection_secondary_image && window.imageFunctions.showSecondaryImage(),
                void 0 === l && $("[data-load-more]").addClass("is-hidden")
            },
            error: function(e, t, a) {
                console.log(e),
                console.log(t),
                console.log(a),
                location.replace(location.protocol + "//" + location.host + filterURL)
            }
        })
    })
}, enableInfiniteScroll = function(e) {
    $(e).length && new Waypoint.Infinite({
        element: $(e)[0],
        items: e,
        more: "[data-load-more]",
        loadingClass: "loading-in-progress",
        onBeforePageLoad: function() {
            $(".js-load-more").hide()
        },
        onAfterPageLoad: function(t) {
            let a = $(`${e} [data-load-more--grid-item]`)
              , o = $(t).find(a);
            $(`${e} > ${e} .thumbnail`).unwrap(e),
            window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies(),
            window.productPage.init(),
            window.productPage.runOptionSelector(o),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            window.PXUTheme.theme_settings.quick_shop_enabled && window.quickShop.init(),
            window.hideNoScript(),
            window.videoFeature.init(),
            window.PXUTheme.theme_settings.collection_secondary_image && window.imageFunctions.showSecondaryImage(),
            Waypoint.refreshAll()
        }
    })
};
if (window.hideNoScript = function() {
    $(".image__container .noscript").addClass("hidden")
}
,
Shopify.queryParams = {},
location.search.length)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
        (aKeyValue = aCouples[i].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
var quickFilter = {
    init: function() {
        var e = []
          , t = ""
          , a = "";
        if (t = $("#sort-by").length ? $("#sort-by").val() : url("?sort_by"),
        $("#tag_filter").length) {
            var o = $("#tag_filter").val();
            if ($("#tag_filter").data("default-collection") != o) {
                urlTag = o.substr(o.lastIndexOf("/") + 1);
                var s = o.substr(o);
                $("#tag_filter option").removeAttr("selected"),
                $('#tag_filter option[value="' + s + '"]').attr("selected", "selected"),
                "all" != urlTag && ($.inArray(urlTag, e) > -1 || e.unshift(urlTag))
            }
        }
        $("[data-option-filter] input:checked").each(function() {
            e.push($(this).val())
        }),
        e = $.makeArray(e),
        $.each(e, function(t, o) {
            t != e.length - 1 ? a += e[t] + "+" : a += e[t]
        }),
        Shopify.queryParams.sort_by = t,
        t = "?" + $.param(Shopify.queryParams).replaceAll("%2B", "+"),
        quickFilter.processUrl(a, t)
    },
    updateView: function(e) {
        $.ajax({
            type: "GET",
            url: e,
            beforeSend: function() {
                $(".product-list--collection").addClass("fadeOut animated loading-in-progress filter-loading"),
                Waypoint.destroyAll()
            },
            success: function(t) {
                let a = $(".product-list--collection [data-load-more--grid-item")
                  , o = $(t).find(a);
                $(".product-list--collection").removeClass("loading-in-progress"),
                $(".product-list--collection").removeClass("filter-loading");
                var s = $(t).find(".breadcrumb_text").html();
                $(".breadcrumb_text").html(s);
                var r = $(t).find(".paginate").html();
                $(".paginate").html(r);
                var l = $(t).find(".sidebar").html();
                $(".sidebar").html(l);
                var n = $(t).find(".paginate").html();
                $(".paginate").empty(),
                $(".paginate").html(n);
                var c = $(t).find(".product-list--collection");
                $(".product-list--collection").remove(),
                c.insertBefore($(".load-more__icon")),
                window.history && window.history.pushState && window.history.pushState("", "", e),
                $(".sidebar__collection-filter").length && window.collectionSidebarFilter.init(),
                window.recentlyViewed.init(),
                window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies(),
                window.productPage.init(),
                window.productPage.runOptionSelector(o),
                Shopify.PaymentButton && Shopify.PaymentButton.init(),
                $("body").off("click", ".swatch-element"),
                window.productPage.productSwatches(),
                $(".swatch_options label").on("click", function() {
                    window.quickShop.toggleSwatchImages($(this))
                }),
                "load_more" === window.PXUTheme.theme_settings.pagination_type && window.enableLoadMoreProducts(),
                "load_more_button" === window.PXUTheme.theme_settings.pagination_type && window.enableLoadMoreButton(".product-list"),
                "infinite_scroll" === window.PXUTheme.theme_settings.pagination_type && window.enableInfiniteScroll(".product-list")
            },
            error: function(t, a, o) {
                console.log(t),
                console.log(a),
                console.log(o),
                location.replace(location.protocol + "//" + location.host + e)
            },
            dataType: "html"
        })
    },
    processUrl: function(e, t) {
        let {pathname: a} = window.location
          , o = t.replace(/\page=(\w+)&/, "")
          , s = "/" === a.slice(-1) ? a : `${a}/`;
        quickFilter.updateView(s + e + o)
    }
};
window.searchAutocomplete = {
    vars: {
        term: "",
        searchPath: window.PXUTheme.routes.search_url,
        displayTimer: ""
    },
    init: function() {
        this.unload(),
        $("[data-autocomplete-true]").on("focus", function() {
            $(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()
        }),
        $(document).on("click focusout", function(e) {
            window.PXUTheme.media_queries.large.matches && 0 === $(e.target).parents(".search__form").length && $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
        }),
        $('[data-dropdown-rel="search"]').on("click", function(e) {
            if (window.PXUTheme.theme_settings.enable_autocomplete && window.PXUTheme.media_queries.medium.matches) {
                e.preventDefault();
                var t = $(this).closest("form").find('[name="type"]').val()
                  , a = $(document).scrollTop();
                window.searchAutocomplete.showMobileSearch(t, a)
            }
        }),
        $(".search-close").on("click touchstart", function() {
            $("body").removeClass("is-active"),
            $(".dropdown_link").removeClass("active_link"),
            $(".dropdown_container").hide(),
            $(".mobile_nav").find("div").removeClass("open"),
            $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
        }),
        $("[data-autocomplete-true] form").on("submit", function(e) {
            e.preventDefault();
            var t = $(this).find('input[name="q"]').val()
              , a = encodeURI(t);
            if ($(this).find('[name="type"]').length > 0)
                var o = $(this).find('[name="type"]').val();
            else
                var o = window.PXUTheme.theme_settings.search_option;
            null == a ? window.location.href = window.PXUTheme.routes.search_url + "?type=" + o : window.location.href = window.searchAutocomplete.vars.searchPath + "?type=" + o + "&q=" + a + "*"
        }),
        $("[data-autocomplete-true] form").each(function() {
            var e = $(this)
              , t = e.find('input[name="q"]');
            $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo(e),
            t.attr("autocomplete", "off").on("input", function() {
                clearTimeout(window.searchAutocomplete.vars.displayTimer),
                $(this).val().length > 3 ? (window.searchAutocomplete.vars.term = $(this).val(),
                window.searchAutocomplete.getResults(window.searchAutocomplete.vars.term, e)) : $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
            })
        })
    },
    getResults: function(e, t) {
        if (t.find('[name="type"]').length > 0)
            var a = t.find('[name="type"]').val();
        else
            var a = window.PXUTheme.theme_settings.search_option;
        jQuery.getJSON("/search/suggest.json", {
            q: e,
            resources: {
                type: a,
                limit: window.PXUTheme.theme_settings.search_items_to_display,
                options: {
                    unavailable_products: "last",
                    fields: "title,body,variants.title,vendor,product_type,tag"
                }
            }
        }).done(function(e) {
            var a = [e.resources.results.products, e.resources.results.pages, e.resources.results.articles]
              , o = [];
            $.each(a, function(e, t) {
                void 0 !== t && t.length > 0 && o.push(t)
            }),
            window.searchAutocomplete.vars.displayTimer = setTimeout(function() {
                window.searchAutocomplete.displayResults(o[0], t)
            }, 500)
        })
    },
    displayResults: function(e, t) {
        var a = t.find(".search__results-wrapper")
          , o = t.find(".search__results");
        if (a.show(),
        o.empty(),
        t.find('[name="type"]').length > 0)
            var s = t.find('[name="type"]').val();
        else
            var s = window.PXUTheme.theme_settings.search_option;
        if (e && e.length > 0)
            $.each(e, function(e, t) {

                let WPD_handels='';
               //for(var i=0;i<products.length;i++) {
                 WPD_handels+=t.handle +',';
               //}
                      
                 var wcpcartdata = [];
                  var xhttp = new XMLHttpRequest();
                  xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                      wcpcartdata=JSON.parse(this.responseText);
                    }
                  };          
                  xhttp.open("GET", '/search/?view=wcp_discount_api&handle='+WPD_handels, false);
                  xhttp.send();
                 
              	//for(var i=0;i<products.length;i++) { 
                  for(var j=0;j<wcpcartdata.products.length;j++){
                    if(t.id == wcpcartdata.products[j].id){
                        t.price=wcpcartdata.products[j].variants[0].wpd_price;          
                        t.price_min=wcpcartdata.products[j].wpd_price_min;
                        t.price_max=wcpcartdata.products[j].wpd_price_max;
                        t.compare_at_price_max=wcpcartdata.products[j].wpd_compare_at_price_min;
                        t.compare_at_price_min=wcpcartdata.products[j].wpd_compare_at_price_max;
                    }
                  }       
               //}
              
                var a = $('<a tabindex="0"></a>').attr("href", t.url);
                if ("/" !== window.PXUTheme.routes.root_url && (a = $('<a tabindex="0"></a>').attr("href", window.PXUTheme.routes.root_url + t.url)),
                t.price) {
                    function s(e) {
                        return "money_with_currency_format" === window.PXUTheme.currency.display_format ? `<span class="money">${window.PXUTheme.currency.symbol}${e} ${window.PXUTheme.currency.iso_code}</span>` : `<span class="money">${window.PXUTheme.currency.symbol}${e}</span>`
                    }
                    if (!0 === t.available) {
                        let r = parseFloat(t.compare_at_price_max)
                          , l = parseFloat(t.compare_at_price_min)
                          , n = parseFloat(t.price_min)
                          , c = parseFloat(t.price_max)
                          , d = parseFloat(t.price);
                        if (r > c || l > n)
                            var u = s(t.price) + ' <span class="was_price">' + s(t.compare_at_price_min) + "</span>";
                        else if (d > 0) {
                            if (n != c)
                                var u = window.PXUTheme.translation.from_text + " " + s(t.price);
                            else
                                var u = s(t.price)
                        } else
                            var u = window.PXUTheme.theme_settings.free_text
                    } else
                        var u = window.PXUTheme.translation.sold_out_text;
                    t.image && a.append('<div class="thumbnail"><img class="lazyload transition--' + window.PXUTheme.theme_settings.image_loading_style + '" src="' + window.utils.addImageDimension(t.image, "_300x") + '" /></div>'),
                    a.append('<div class="search-title">' + t.title + '<br><span class="item-pricing price">' + u + "</span></div>")
                } else
                    t.summary_html ? ("NULL" != t.image && a.append('<div class="thumbnail"><img class="lazyload transition--' + window.PXUTheme.theme_settings.image_loading_style + '" src="' + window.utils.addImageDimension(t.image, "_300x") + '" /></div>'),
                    a.append('<div class="search-title">' + t.title + '<br><span class="item-description">' + t.summary_html.replace(/(<([^>]+)>)/ig, "").slice(0, 25) + " </span></div>")) : t.published_at && a.append('<div class="search-title">' + t.title + '<br><span class="item-description">' + t.body.replace(/(<([^>]+)>)/ig, "").slice(0, 25) + " </span></div>");
                a.wrap('<li class="item-result"></li>'),
                o.append(a.parent())
            }),
            o.append('<li class="all-results"><span class="search-title see-all"><a href="' + this.vars.searchPath + "?type=" + s + "&q=" + this.vars.term + '*"><span>' + window.PXUTheme.translation.all_results + '</span><span class="icon-right-arrow"></span></a></span></li>'),
            (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) && window.currencyConverter.init(),
            o.parents(".search__results-wrapper").addClass("results-found");
        else {
            var r = '<li class="item-result"><span class="no-results search-title">' + window.PXUTheme.translation.no_results + "</span></li>";
            o.append(r),
            o.parents(".search__results-wrapper").removeClass("results-found")
        }
        o.show()
    },
    showMobileSearch: function(e, t) {
        $("body").css("max-height", window.innerHeight),
        $(".mobile-search").fadeIn(200),
        /iPad|iPhone|iPod/.test(navigator.platform) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 ? $(".mobile-search input#q").focus() : setTimeout(function() {
            $(".mobile-search input#q").focus()
        }, 205),
        document.body.style.position = "fixed",
        document.body.style.top = "-" + t + "px",
        $(".mobile-search").css("top", t);
        var a = window.innerHeight - 60;
        $(".mobile-search .search__results-wrapper").css("max-height", a),
        e ? $('.mobile-search [name="type"]').val(e) : $('.mobile-search [name="type"]').val(window.PXUTheme.theme_settings.search_option),
        $(".search-form .close-search").on("click touchstart", function(e) {
            e.preventDefault(),
            e.stopPropagation(),
            window.searchAutocomplete.hideMobileSearch(t),
            $("[data-autocomplete-true] .search__results-wrapper").hide().removeClass("results-found")
        }),
        $(".search-form .submit-search").on("click touchstart", function(e) {
            $(this).parents("form").submit()
        })
    },
    hideMobileSearch: function(e) {
        $("body").css("max-height", "none"),
        document.body.style.position = "",
        document.body.style.top = "",
        window.scrollTo(0, e),
        $(".mobile-search").fadeOut(200),
        $('.mobile-search [name="q"]').val(""),
        $("body").off("focus", ".search-form .close-search"),
        $("body").off("focus", ".search-form .submit-search")
    },
    unload: function() {
        $("body").off("focus", "[data-autocomplete-true] input"),
        $('input[name="q"]').off(),
        $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off(),
        $(".search__results-wrapper").remove()
    }
},
window.collectionSidebarFilter = {
    init: function() {
        $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(),
        (()=>{
            let e = document.querySelector("[data-sidebar]");
            if (!e)
                return;
            let t = e.querySelectorAll("[data-sidebar-block]");
            window.PXUTheme.media_queries.medium.matches || t.forEach(e=>{
                e.querySelector("[data-active-legacy-filter]") && (e.open = !0)
            }
            )
        }
        )(),
        ("types" === $.url(2) || "vendors" === $.url(2)) && $(".sidebar__collection-filter").remove(),
        $(".sidebar-block:empty").prev().css("border-bottom", "none"),
        window.recentlyViewed.init()
    },
    clearAllFilters: function() {
        $("[data-option-filter] input").prop("checked", !1),
        $("[data-option-filter] input").trigger("change"),
        window.recentlyViewed.init()
    },
    clearSelectedFilter: function(e) {
        $("#tag_filter").length && e.find("[data-option-filter] input").val() === $("#tag_filter option:selected ").val().substr($("#tag_filter option:selected ").val().lastIndexOf("/") + 1) && $("#tag_filter").val($("#tag_filter option:first").val()),
        e.find("[data-option-filter] input").prop("checked", !1),
        e.find("[data-option-filter] input").trigger("change"),
        window.recentlyViewed.init()
    }
},
window.sidebarAccordions = {
    init: function() {
        let e = document.querySelector("[data-sidebar]");
        if (!e)
            return;
        let t = e.querySelectorAll("[data-sidebar-block]")
          , a = e.querySelector("[data-faceted-filter-form]")
          , o = "true" === e.dataset.sidebarAllowToggle
          , s = ()=>t.forEach(e=>{
            e.open = !1
        }
        )
          , r = ()=>t.forEach(e=>{
            e.open = !0
        }
        )
          , l = !1
          , n = ()=>{
            window.PXUTheme.media_queries.medium.matches ? (l || s(),
            l = !0) : (o || r(),
            l = !1)
        }
        ;
        if (n(),
        window.addEventListener("resize", n),
        a) {
            a.addEventListener("keypress", e=>{
                e.target.classList.contains("faceted-filter-group-display__list-item-input") && 13 == event.keyCode && (e.target.checked ? e.target.checked = !1 : e.target.checked = !0)
            }
            );
            let c = document.querySelector("[data-sort-by]");
            a.addEventListener("change", e=>{
                if ("number" != e.target.type) {
                    if (c) {
                        let t = c.value
                          , o = new FormData(a)
                          , s = new URLSearchParams(o);
                        s.set("sort_by", t),
                        window.location.search = s
                    } else
                        a.submit()
                }
            }
            )
        }
        t.forEach(e=>{
            let t = e.querySelector("summary");
            if (!t)
                return;
            let a = window.animations.transition({
                el: e,
                state: e.open ? "open" : "closed",
                stateAttribute: "data-sidebar-block-state",
                stateChangeAttribute: "data-sidebar-block-animation"
            });
            t.addEventListener("click", s=>{
                if (s.preventDefault(),
                !window.PXUTheme.media_queries.medium.matches && !o)
                    return;
                let {height: r} = t.getBoundingClientRect();
                e.style.setProperty("--closed-height", `${r}px`),
                e.open ? (e.style.setProperty("--open-height", `${e.scrollHeight}px`),
                a.animateTo("closed").then(()=>{
                    e.open = !1
                }
                )) : (e.open = !0,
                a.animateTo("open", {
                    onStart() {
                        e.style.setProperty("--open-height", `${e.scrollHeight}px`)
                    }
                }))
            }
            )
        }
        )
    }
},
"bold" == window.PXUTheme.theme_settings.slideshow_arrow_size ? (window.arrowSize = {
    x0: 10,
    x1: 40,
    y1: 50,
    x2: 80,
    y2: 50,
    x3: 50
},
window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>',
window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>') : "light" == window.PXUTheme.theme_settings.slideshow_arrow_size ? (window.arrowSize = {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 62,
    y2: 40,
    x3: 22
},
window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>') : "regular" == window.PXUTheme.theme_settings.slideshow_arrow_size && (window.arrowSize = {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 70,
    y2: 40,
    x3: 30
},
window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'),
window.isScreenSizeLarge = function e() {
    if (window.matchMedia("(min-width: 1024px)").matches)
        return !0
}
,
window.utils = {
    createAccordion: function(e, t, a) {
        var o = $(e)
          , s = $(e).find(t)
          , r = $(e).find(a)
          , l = e + " " + t;
        if (e.indexOf(".accordion-tabs") >= 0) {
            var n = $.map(s, function(e, t) {
                return [e, r[t]]
            });
            o.empty(),
            $.each(n, function(e, t) {
                o.append(this)
            }),
            r.removeClass("active"),
            o.find(".active").next().slideToggle(),
            t = e + "> a"
        }
        $(e).children("a").each(function(e, t) {
            var t = $(this)
              , a = t.attr("href");
            t.attr("data-tab-value", a),
            t.removeAttr("href")
        }),
        $(e).find(t + ".active").next().slideToggle(),
        $("body").on("click", l, function(e) {
            e.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        })
    },
    mobileAccordion: function(e, t, a) {
        $container = $(e),
        $tab = $(e).find(t),
        $content = $(e).find(a),
        $(t + ".active").next().slideToggle(),
        $("body").on("click", t, function(e) {
            e.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        })
    },
    mobileParentActiveAccordion: function(e, t, a) {
        $container = $(e),
        $tab = $(e).find(t),
        $content = $(e).find(a),
        $(t + ".active").parent().next().slideToggle(),
        $("body").on("click", t, function(e) {
            e.preventDefault(),
            $(this).toggleClass("active"),
            $(this).parent().next().slideToggle()
        })
    },
    initializeTabs: function() {
        $("ul.tabs > li > a").attr("data-no-instant", !0),
        $("body").on("click", "ul.tabs > li > a", function(e) {
            e.preventDefault();
            var t = $(this).attr("href");
            "#" == t.charAt(0) && ($("ul.tabs > li > a.active").removeClass("active"),
            $(this).addClass("active"),
            $(this).parents("ul.tabs").next().find(t).show().css({
                display: "block"
            }).addClass("active").siblings().hide().removeClass("active"))
        })
    },
    scrollToTop: function(e, t) {
        void 0 != t ? $("html, body").animate({
            scrollTop: $(e).offset().top - t
        }, 1e3) : $("html, body").animate({
            scrollTop: $(e).offset().top
        }, 1e3)
    },
    initializeSectionWrapper: function() {
        let e = document.querySelector(".section-wrapper .shopify-section");
        e && (window.navigationDesktopManager.initAll(),
        e.classList.contains("under-menu") && e.querySelector(".full-width--true") ? ($(".header").hasClass("header-background--solid") || ($(".header").parent().addClass("feature_image"),
        $(".header").addClass("is-absolute")),
        $(".feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(),
        $(".secondary_logo--true").find(".primary_logo").hide()),
        window.headerFader.updateShouldFade(!0)) : ($(".feature_image").removeClass("feature_image"),
        $(".header.is-absolute").removeClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(),
        $(".secondary_logo--true").find(".primary_logo").show()),
        window.headerFader.updateShouldFade(!1)))
    },
    enableDisclosure: function() {
        var e = $("[data-disclosure]")
          , t = $("[data-disclosure-toggle]")
          , a = $(".disclosure__list-wrap");
        function o(e) {
            e.siblings(".disclosure__list-wrap").is(":off-right") && e.siblings(".disclosure__list-wrap").addClass("disclosure--left")
        }
        function s(e, o) {
            !0 === e ? (t.not(o).removeClass("is-clicked"),
            t.not(o).attr("aria-expanded", "false")) : (t.removeClass("is-clicked"),
            t.attr("aria-expanded", "false")),
            a.removeClass("disclosure--left")
        }
        $("body").on("keyup", function(e) {
            "27" == e.which && s()
        }),
        e.on("mouseleave", function(e) {
            s()
        }),
        t.on("mouseenter focus", function(e) {
            s(!0, this);
            var t = $(e.currentTarget);
            t.attr("aria-expanded", "true").addClass("is-clicked"),
            o(t)
        }),
        $(".disclosure__button").on("focusout", function(e) {
            (!$(e.relatedTarget).hasClass("disclosure__button") || $(e.relatedTarget).hasClass("disclosure__toggle")) && s()
        }),
        t.on("touchstart", function(e) {
            if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                var t = $(e.currentTarget);
                s(!0, this),
                t.hasClass("is-clicked") ? (t.attr("aria-expanded", "false").removeClass("is-clicked"),
                a.removeClass("disclosure--left")) : (t.attr("aria-expanded", "true").addClass("is-clicked"),
                o(t))
            }
        })
    },
    addImageDimension: function(e, t) {
        var a = e.lastIndexOf(".");
        return e.substring(0, a) + t + e.substring(a)
    },
    unload: function(e) {
        $("[data-disclosure]").off(),
        $("[data-disclosure-toggle]").off()
    }
},
window.sliderBlock = {
    select: function(e, t) {
        var a = t.find(".gallery-cell").map(function() {
            return String($(this).data("block-id"))
        })
          , o = t.find("[data-slider-id]");
        o.data("slideshow-text-animation");
        var s = o.data("flickity");
        o.flickity("pausePlayer");
        for (var r = 0; r < a.length; r++)
            if (a[r] === e) {
                var l = r;
                l !== s.selectedIndex && o.flickity("select", parseInt(l), !1, !0)
            }
    },
    deselect: function(e) {
        var t = e.find(".flexslider").data("flexslider");
        t && t.flickity("unpausePlayer")
    }
},
window.quickShop = {
    init: function() {
        $("body").on("click", ".js-quick-shop-link", e=>{
            e.preventDefault();
            let t = $(e.currentTarget);
            window.productPage.loadQuickshop(t.data("url")).then(e=>{
                if (!e)
                    return;
                let a = e.html;
                $(".js-quick-shop").html(a.content),
                $(".fancybox-active").length || $.fancybox.open($(".js-quick-shop"), {
                    baseClass: `quick-shop__lightbox product-${t.data("id")}`,
                    hash: !1,
                    infobar: !1,
                    toolbar: !1,
                    loop: !1,
                    smallBtn: !0,
                    video: {
                        autoStart: !1
                    },
                    touch: !1,
                    mobile: {
                        preventCaptionOverlap: !1,
                        toolbar: !0,
                        buttons: ["close"]
                    },
                    beforeLoad() {
                        window.productPage.init(),
                        window.productPage.runOptionSelector($(".js-quick-shop")),
                        window.accordion.init(),
                        videoFeature.setupVideoPlayer(),
                        productMedia.setupMedia(),
                        utils.initializeTabs(),
                        productPage.productSwatches(),
                        Shopify.PaymentButton && Shopify.PaymentButton.init()
                    },
                    afterShow(e, t) {
                        let {src: a} = t
                          , o = $(a).find(".quick-shop");
                        o.addClass("quick-shop--loaded"),
                        o.addClass("content-loaded")
                    },
                    beforeClose(e, t) {
                        let {src: a} = t
                          , o = $(a).find(".quick-shop");
                        o.removeClass("quick-shop--loaded"),
                        o.removeClass("content-loaded")
                    }
                })
            }
            ).catch(e=>console.error(e))
        }
        ),
        $(".swatch_options label").on("click", function() {
            window.quickShop.toggleSwatchImages($(this))
        })
    },
    toggleSwatchImages: function(e) {
        var t = $(e).data("image")
          , a = $(e).parents(".thumbnail").find(".image__container img");
        a.attr("src", t),
        a.attr("srcset", t)
    }
},
window.newsletter_popup = {
    init: function() {
        var e = window.Cookies.get("popup")
          , t = parseInt(window.PXUTheme.theme_settings.newsletter_popup_days)
          , a = 0 != t;
        if (a && "open" == e)
            return !1;
        window.newsletter_popup.open(),
        a && window.Cookies.set("popup", "open", {
            expires: t,
            path: "",
            domain: "",
            sameSite: "None",
            secure: !0
        })
    },
    open: function() {
        var e = parseInt(window.PXUTheme.theme_settings.newsletter_popup_seconds);
        (window.PXUTheme.theme_settings.newsletter_popup_mobile || window.PXUTheme.media_queries.large.matches) && setTimeout(function() {
            $.fancybox.open($(".js-newsletter-popup"), {
                baseClass: "newsletter__lightbox",
                hash: !1,
                infobar: !1,
                toolbar: !1,
                loop: !0,
                smallBtn: !0,
                mobile: {
                    preventCaptionOverlap: !1,
                    toolbar: !0,
                    buttons: ["close"]
                }
            })
        }, 1e3 * e)
    }
},
window.productMedia = {
    models: [],
    setupMedia: function() {
        var e = {
            controls: ["zoom-in", "zoom-out", "fullscreen"],
            focusOnPlay: !1
        };
        $($("model-viewer", $(".js-product-gallery, .js-gallery-modal"))).each(function(t, a) {
            a = new Shopify.ModelViewerUI(a,e),
            window.productMedia.models.push(a)
        }),
        $(".product-gallery__model model-viewer").on("mousedown", function() {
            window.productMedia.hideModelIcon(this)
        })
    },
    showModelIcon: function(e) {
        $(e).find(".button--poster, .model-icon-button-control").show()
    },
    hideModelIcon: function(e) {
        $(e).find(".button--poster, .model-icon-button-control").hide()
    }
},
window.videoEl = {
    playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
    playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
    muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
    progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
    volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
    fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
},
window.videoControls = window.videoEl.playButtonIcon + '<div class="plyr__controls">' + window.videoEl.playButton + window.videoEl.progressInput + window.videoEl.muteButton + videoEl.volume + window.videoEl.fullscreen + "</div>",
window.globalVideoPlayers = [],
window.videoPlayers = [],
window.videosInRecommendedProductsPlayer,
window.videoFeature = {
    init: function() {
        this.setupVideoPlayer(),
        this.setupRecommendedVideoPlayer()
    },
    setupVideoPlayer: function() {
        var e = document.querySelectorAll("[data-html5-video] video, [data-youtube-video]")
          , t = Plyr.setup(e, {
            controls: window.videoControls,
            ratio: this.aspect_ratio,
            fullscreen: {
                enabled: !0,
                fallback: !0,
                iosNative: !0
            },
            storage: {
                enabled: !1
            }
        });
        window.globalVideoPlayers && $.each(t, function(e, t) {
            window.globalVideoPlayers.push(t)
        });
        var a = $("[data-video-loop]").data("video-loop") || !1;
        $.each(t, function(e, t) {
            t.loop = a,
            window.videoPlayers.push(t)
        }),
        this.setupListeners()
    },
    setupPlayerForRecentlyViewedProducts: function(e) {
        if (e) {
            var t = new Plyr(e,{
                controls: window.videoControls,
                ratio: this.aspect_ratio,
                fullscreen: {
                    enabled: !0,
                    fallback: !0,
                    iosNative: !0
                },
                storage: {
                    enabled: !1
                }
            });
            null !== window.videoPlayers && (window.videoPlayers.push(t),
            this.setupListeners())
        }
    },
    setupRecommendedVideoPlayer: function() {
        var e = document.querySelectorAll(".product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]");
        if (e.length > 0) {
            if (window.videosInRecommendedProductsPlayer = Plyr.setup(e, {
                controls: window.videoControls,
                fullscreen: {
                    enabled: !0,
                    fallback: !0,
                    iosNative: !0
                },
                storage: {
                    enabled: !1
                }
            }),
            null !== window.videoPlayers) {
                var t = window.videoPlayers.concat(window.videosInRecommendedProductsPlayer);
                window.videoPlayers = t
            } else
                window.videoPlayers = videosInRecommendedProductsPlayer
        }
        this.setupListeners()
    },
    setupListeners: function() {
        $.each(window.videoPlayers, function(e, t) {
            var a, o = t.id || t.media.dataset.plyrVideoId;
            t.isHTML5 && (a = $(t.elements.wrapper).find("video")).attr("data-plyr-video-id", o)
        }),
        $.each(window.globalVideoPlayers, function(e, t) {
            t.on("play", function(e) {
                var t = e.detail.plyr;
                $.each(window.globalVideoPlayers, function(e, a) {
                    t.id != a.id && a.pause()
                })
            })
        })
    },
    enableVideoOnHover: function(e) {
        var t, a = e.find("[data-html5-video]"), o = e.find("[data-youtube-video]");
        a.length > 0 ? t = a.find("[data-plyr-video-id]").data("plyr-video-id") : o.length > 0 && (t = o.find("iframe").attr("id")),
        t && $.each(window.videoPlayers, function(e, a) {
            (a.id == t || a.media.id == t) && (a.toggleControls(!1),
            a.muted = !0,
            a.play())
        })
    },
    disableVideoOnHover: function(e) {
        var t, a = e.find("[data-html5-video]"), o = e.find("[data-youtube-video]");
        a.length > 0 ? t = a.find("[data-plyr-video-id]").data("plyr-video-id") : o.length > 0 && (t = o.find("iframe").attr("id")),
        t && $.each(window.videoPlayers, function(e, a) {
            (a.id == t || a.media.id == t) && a.playing && a.pause()
        })
    }
};
